// local server
// export const BASE_URL = "http://103.176.78.20:5001";
// export const BASE_URL = "http://10.8.0.1:5000";
// export const BASE_URL = "http://localhost:5001";

// export const BASE_URL = "https://simolek.jabarprov.go.id/api";
// export const PDF_URL = "https://img.zcode.id/jabar/";
// export const PDF_URL = "http://localhost/bumd-pdf/";

// prod server
export const BASE_URL = "https://simolek.jabarprov.go.id/api";
export const PDF_URL = "https://simolek.jabarprov.go.id/doc/";
